<template>
    <div class="project-details">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4 mt-4">
                <div class="text-left mt-3 ml-5 mb-4"><a-icon class="mr-1" type="arrow-left" /> <span class="go-back" @click="goBack">Go Back</span></div>
            </div>
            <div class="container-fluid">
                <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8 mt-lg-3">
                    <div class="bg-light p-2 mt-3 border add-rounded text-center scrollbar jobs-post">
                        <div class="d-flex justify-content-around flex-wrap">
                            <JobPost title="CO" status="Completed" id="23498" text="Completed Html Catalogue" />
                            <JobPost title="CO" status="Completed" id="23498" text="Completed Html Catalogue" />
                            <JobPost title="CO" status="In Progress" id="23498" text="Completed Html Catalogue" />
                            <JobPost title="CO" status="In Progress" id="23498" text="Completed Html Catalogue" />
                            <JobPost title="CO" status="In Progress" id="23498" text="Completed Html Catalogue" />
                            <div class="new-project p-4 shadow-sm border bg-white my-3">
                                <div class="d-flex justify-content-center">
                                    <div class="mt-4 pt-2">
                                        <a-icon class="add-new" style="font-size: 80px" type="plus-circle" theme="filled" @click="showModal" />
                                        <p class="font-weight-bolder mt-2">Post a New Job</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5">
                        <a-tabs defaultActiveKey="1">
                            <a-tab-pane tab="Details" key="1">
                                <div class="bg-light border add-rounded p-4 mt-4">
                                    <div class="row">
                                        <div class="col-12 col-sm-12 col-md-9">
                                            <div class="row pl-3">
                                                <div><h5 class="font-weight-bolder text-left">Customise Wordpress Login</h5></div>
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <span><a-icon class="mr-2" type="info-circle" style="position:relative; bottom: 3px;font-size: 16px;"/>click to copy</span>
                                                    </template>
                                                    <span class="ml-2">
                                                        <div class="kova-id ml-3 text-white px-3" style="height: 20px">ID: 23498</div>
                                                    </span>
                                                </a-tooltip>
                                                    </div>
                                            <h5 class="text-left mt-3">Brief</h5>
                                            <p class="text-left">
                                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                                voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita
                                                kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
                                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                            </p>
                                            <h5 class="text-left mt-3">Skills Required</h5>
                                            <div class="text-left d-flex flex-wrap">
                                                <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2"  v-for="skill in skills" :key="skill">
                                                    {{skill}}</span>
                                            </div>
                                            <h5 class="text-left mt-3">Budgets</h5>
                                            <div class="row pl-3">
                                                <div><h4 class="text-left font-weight-bolder">$1,340 - $3,000 .</h4></div>
                                                <div class="ml-3 mt-2 incr-font-2 font-italic">$20.00/hr</div>
                                                
                                                    <button class="btn-kovatek shadow py-2 px-3 px-md-4 btn-rounded ml-4 ml-md-5 pl-md-4">Open for new Bidders</button>
                                            </div>
                                            <div class="mt-3">
                                                <p class="ant-color text-left" @click="showOtherDetails">View More Details<a-icon class="ml-2" type="double-right" rotate="90" /></p>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-3">
                                            <div class="text-right font-weight-bolder"><font-awesome-icon icon="clock" class="mr-2"/>Hired 4</div>
                                        </div>
                                    </div>
                                    <div class="" v-if="otherDetails">
                                        <hr>
                                        <div class="">
                                            <h6 class="text-left">Project Specification</h6>
                                            <h4 class="font-weight-bolder text-left">UI/UX Prototype</h4>
                                            <hr>
                                        </div>
                                        <div class="">
                                            <h6 class="text-left">Hours of Commitment</h6>
                                            <h4 class="font-weight-bolder text-left">Hourly</h4>
                                            <hr>
                                        </div>
                                        <div class="">
                                            <h6 class="text-left">Project Timeline</h6>
                                            <h4 class="font-weight-bolder text-left">3 - 6 months</h4>
                                            <hr>
                                        </div>
                                        <div class="">
                                            <h6 class="text-left">Numbers of Developer</h6>
                                            <h4 class="font-weight-bolder text-left">One Developer</h4>
                                            <hr>
                                        </div>
                                        <div class="">
                                            <h6 class="text-left">Skill Required</h6>
                                            <h4 class="font-weight-bolder text-left">Web Application</h4>
                                            <h4 class="font-weight-bolder text-left">Front End</h4>
                                            <h4 class="font-weight-bolder text-left">Blockchain</h4>
                                            <h4 class="font-weight-bolder text-left">Integration</h4>
                                            <hr>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4"/>
                            </a-tab-pane>
                            <a-tab-pane tab="Proposals" key="2" forceRender>
                                <div class="mt-4 mb-5">
                                    <div class="p-4 bg-light border shadow-sm add-rounded">
                                        <div :key="work" v-for="work in workHistory">
                                            <div class="row">
                                            <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                                            </div>
                                            <div class="col-9 col-sm-9 col-md-7 text-left">
                                                <h5 class="font-weight-bolder kova-text">{{work.title}}</h5>
                                                <!-- <span>
                                                    <span :key="n" v-for="n in work.star"><font-awesome-icon icon="star" size=""></font-awesome-icon></span> <b>{{work.star}}.00</b> 
                                                    <span class="font-weight-light">{{work.duration}}</span>
                                                </span> -->
                                                <p class="font-italic ctrl-size-2">{{work.comment}}</p>
                                                <div class="text-left d-flex flex-wrap">
                                                    <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2"  v-for="skill in proSkills" :key="skill">
                                                        {{skill}}</span>
                                                </div>
                                            </div>
                                            
                                            <!-- <div class="col-md-3">

                                            </div> -->
                                            <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 text-right float-text">
                                            <h5 class="font-weight-bolder kova-text">${{work.earned}}</h5>
                                            <h6>Web Developer <span class="text-uppercase intermediate">intermediate</span> </h6>
                                            <!-- <h6>{{work.hours}} hours </h6> -->
                                            <span class="ml-2"><img class="mr-2" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder ctrl-size-1">9.5</span><span class="ml-2 ctrl-size-2">56 reviews</span></span>

                                            </div>
                                        </div>
                                        <hr>
                                        </div>
                                        
                                    </div>
                                </div>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                    <div class="">
                        <h5 class="font-weight-bolder kova-text text-left mt-5 py-3">Completed Project</h5>
                    </div>
                    <div class="bg-light p-4 border add-rounded text-center mb-5">
                        <div :key="work" v-for="work in workHistory">
                            <div class="row">
                            <div class="class col-3 col-sm-3 col-md-2 pl-1">
                                <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height" />
                            </div>
                            <div class="col-9 col-sm-9 col-md-7 text-left">
                                <h4 class="font-weight-bolder kova-text">{{work.title}}</h4>
                                <p class="font-italic text-size2">{{work.comment}}</p>
                                <p class="text-left font-weight-bolder ctrl-size mb-1"><font-awesome-icon class="ctrl-size" icon="clock" /> 30 minutes ago for</p>
                                <p class="text-left font-weight-bolder ctrl-size my-0"><span class="bid-color mr-2"><font-awesome-icon class="ctrl-size mr-2" icon="gavel" />2 bids</span><font-awesome-icon class="ctrl-size" icon="tag" /> PHP, Website Design, Wordpress, CSS, HTML</p>
                            </div>
                        
                            <div class="pl-4 pl-sm-5 pl-md-3 mt-3 mt-md-0 col-12 col-sm-12 col-md-3 float-text">
                                    <h5 class="font-weight-bolder kova-text">$169</h5>
                                    <!-- <div class="pt-0 mt-1 mt-md-5 pt-md-5">
                                        <font-awesome-icon class="icon-size mr-3" style="color:#FE9816" icon="bookmark" />
                                    </div> -->
                            </div>
                        </div>
                        <hr>
                    </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4 px-3 pl-lg-0 pr-lg-3">
                    <div class=""></div>
                    <div class="ml-lg-4" style="position:sticky;top:0;">
                        <Notifications />
                        <Messages />
                    </div>
                </div>
            </div>
            
            </div>
            <div class="modal">
                <!-- <a-button type="primary" @click="showModal">
                Open Modal with customized footer
                </a-button> -->
                <a-modal v-model="visible" title="" onOk="handleOk" width="750px">
                <template slot="footer">
                    <a-button key="back" @click="handleCancel">Cancel</a-button>
                    <a-button key="submit" style="background-color:#20409a; color: #fff" :loading="loading" @click="showCallScheduled">
                    schedule
                    </a-button>
                </template>
                    <div class="mt-4 p-4 bg-light">
                    </div>
                </a-modal>
            </div>
            <div>
                <a-modal v-model="callScheduled" title="" onOk="handleOk" width="600px">
                <template slot="footer">
                    <a-button key="submit" style="background-color:#20409a; color: #fff" @click="callScheduledOk"> Ok </a-button>
                </template>
                    <div class="mt-4 p-4 bg-light"></div>
                </a-modal>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import JobPost from '@/components/JobPost.vue'
import Notifications from '@/components/Notifications.vue'
import Messages from '@/components/Messages.vue'

export default {
    name: 'project-details',
    components: {
        Navbar, Footer, JobPost, Notifications, Messages
    },
    data(){
        return {
            workHistory: [
                {title: 'Customise Wordpress login', duration: ' Mar 2016 - Sep 2018', star: 5, status:"You are hired", comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48},
                {title: 'Wordpress login', star: 5, status:"Undergoing Interview", comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future updatable',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19}
            ],
            skills: [
                'Laravel Framework', 'Nodejs','Golang','jQuery', 'JavaScript','database', 'Modeling','Vue.js','Express.js', 'Ext JS', 'Docker'
            ],
            loading: false,
            visible: false,
            callScheduled: false,
            otherDetails: false,
        }
    },
    methods: {
        styleScroll: function(){
                let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
                let scrollbarDiv = document.querySelector('.scrollbar');
                if (!isChrome && !isSafari) {
                    scrollbarDiv.innerHTML = 'You need Webkit browser to run this code';
                }
        },
        goBack(){
            this.$router.go(-1)
        },
        showModal() {
            this.visible = true;
        },
        handleOk() {
            this.loading = true;
            setTimeout(() => {
            this.visible = false;
            this.loading = false;
            }, 3000);
        },
        handleCancel() {
            this.visible = false;   
        },
        showCallScheduled(){
            this.loading = true;
                setTimeout(() => {
                this.visible = false;
                this.loading = false;
                this.callScheduled = true;
                }, 3000);
        },
        callScheduledOk(){
            this.callScheduled = false;
        },
        showOtherDetails(){
            this.otherDetails = !this.otherDetails
            
        }
    },
    mounted(){
    }
}
</script>
<style scoped>
.browse-list{
    width: 80%;
}
.sort-by{
    position: relative;
    top:33px;
}
.icon-size{
    font-size: 25px;
}
.icon-size1{
    font-size: 20px;
}
.img-height{
    width: 60px;
    height: 60px;
}
.icon-env{
    font-size: 20px;
}
.ctrl-size{
    font-size: 10px;
}
.ctrl-size-1{
    font-size: 20px
}
.ctrl-size-2{
    font-size: 11px;
}
.latest{
    color: #2db7f5;
}
.jobs-post{
    height: 400px;
    overflow-y: scroll;
}
.new-project{
    width: 260px;
}
.add-new{
    color: #20409a;
}
.add-new:hover{
    color:#0c2b80
}
.bg-skills{
    background-color: #4BB38E;
    color: #fff;
}
@media screen and (min-width: 992px) and (max-width: 1325px){
  .new-project{
        width: 300px;
    }  
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .img-height{
        width: 60px;
        height: 60px;
    }
    .new-project{
        width: 260px;
    } 
}

@media screen and (min-width: 768px) and (max-width: 991px){
   
}

@media screen and (max-width: 767px){
    .float-text{
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6{
        float: left;
    }
    
}

@media screen and (max-width: 550px){
    .ctrl-search{
        width: 55%;
    }
    .img-height{
        width: 65px;
        height: 65px;
    }
}
</style>